import { A } from '@solidjs/router'
import { Component } from 'solid-js'
import SignOutButton from '../../components/SignOutButton'
import getSessionUserId from '../../rx/shared/session/getSessionUserId'

const SignOutPage: Component = () => {
  return (
    <div class="d-flex justify-content-center">
      <div class="col-6">
        <h1>Simple Tactics</h1>
        <br />
        {getSessionUserId() ? <SignOutButton /> : <>
          <p>
            You are not signed in
          </p>
          <A class="btn btn-primary" href="/auth/sign-in">Sign In</A>
        </>}
      </div>
    </div>
  )
}

export default SignOutPage
